import Swiper from 'swiper/bundle';

import 'swiper/css';
import 'swiper/css/pagination';

export default class Banner {
    constructor() {
        this.bannerlength = '';
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const banners = document.querySelectorAll('.swiper-slide');
        this.bannerlength = this.bannerlength === '' ? banners.length : this.bannerlength;
        
        
        const option = {
            autoplay: { delay: 5000, disableOnInteraction: false },
            centeredSlides: true,
            slidesPerView: 1.8,
            spaceBetween: 0,
            loop: true,
            speed: 700,
            pagination: { el: '.js-banner-pagenation', clickable: true },

            breakpoints: {
                835: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
            },
        };

        const swiper = new Swiper('.js-banner-swiper', option);

        if (this.bannerlength > 0) {
            this.setPagenationSize();
        }
    }

    setPagenationSize() {
        const bannerWidthPer = 100 / this.bannerlength;

        const pagenation = document.querySelector('.js-banner-pagenation');
        const pagenateItem = pagenation.querySelectorAll('span');
        pagenation.setAttribute('data-num', this.bannerlength);

        pagenateItem.forEach((el) => {
            el.style.width = `${bannerWidthPer}%`;
        });
    }
}
